import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Navigation: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated, user } = useAuth();

  return (
    <nav className="navigation">
      <div className="nav-content">
        <div className="nav-left">
          <Link
            to="/"
            className={`nav-brand ${location.pathname === '/' ? 'active' : ''}`}
          >
            Flow.
          </Link>
        </div>

        <div className="nav-right">
          <Link
            to="/explore"
            className={`nav-link ${location.pathname === '/explore' ? 'active' : ''}`}
          >
            Explore
          </Link>
          {isAuthenticated ? (
            <Link
              to="/profile"
              className={`nav-button ${location.pathname === '/profile' ? 'active' : ''}`}
            >
              Profile
            </Link>
          ) : (
            <Link
              to="/login"
              className={`nav-button ${location.pathname === '/login' ? 'active' : ''}`}
            >
              Login
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;